<template>
    <Portal to="sidepanel">
        <SidePanel
            :key="`addPaymentMethodSidePanel-${String($.vnode.key)}`"
            class="add-payment-method"
            name="Add Payment Method"
            width="medium"
            :disable-transition="disableTransition"
            :is-dark-mode="isDarkMode"
            :class="{ 'add-payment-method--full-height': showFullHeight }"
            @close="emitClose"
        >
            <PaymentFields
                mode="setup"
                class="add-payment-method__fields"
                @checkoutCompleted="checkoutCompleted"
            />
        </SidePanel>
    </Portal>
</template>

<script lang="ts">
import UIKit from '@pocketprep/ui-kit'
import { Vue, Component, Prop, Emit } from 'vue-facing-decorator'
import PaymentFields from '@/components/PaymentFields.vue'
import { stripeModule } from '@/store/stripe/module'
import { userModule } from '@/store/user/module'
import { toastModule } from '@/store/toast/module'

@Component({
    components: {
        SidePanel: UIKit.SidePanel,
        PocketButton: UIKit.Button,
        PocketInput: UIKit.Input,
        PocketSelect: UIKit.Select,
        PaymentFields,
    },
})
export default class AddPaymentMethodSidePanel extends Vue {
    @Prop({ default: false }) disableTransition!: boolean
    @Prop({ default: false }) showFullHeight!: boolean

    isLoading = false

    get isDarkMode () {
        return userModule.state.settings.isDarkMode
    }

    async checkoutCompleted () {
        this.isLoading = true
        if (import.meta.env.VUE_APP_STRIPE_PUBLISHABLE_KEY) {
            await stripeModule.actions.loadNewPaymentMethods()
            toastModule.actions.displayToast({
                title: 'Card added successfully',
            })
            this.emitClose()
        }
        this.isLoading = false
    }

    @Emit('close')
    emitClose () {
        return true
    }
}
</script>

<style lang="scss" scoped>
.add-payment-method {
    &--full-height {
        top: 0;
        height: 100%;
    }

    :deep(.uikit-side-panel__content) {
        padding: 36px 0;
    }
}
</style>